import URLstateContext from "../../../provider/CommonContext";
import React, { useEffect, useState, useContext, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from 'date-fns';
import { GetPostMethodData, DecryptAESdata } from "../../../provider/ServiceProvider";
import { Vortex } from 'react-loader-spinner';
import animation from '../../../images/jm-animation.gif';
import '../CommunicationHub.css';
// import Pagination from 'rc-pagination';
import { Pagination } from "antd";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from 'react-icons/ai';
import "./MediaIntraction.css"
import { IoArrowForwardCircle } from "react-icons/io5";
import Arrow  from "../../../images/newIcon/file-download 1.svg"

function MediaIntraction() {
    const [data, setData] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const [current, setCurrent] = useState(1);
    const [perPage, setPerPage] = useState(5);
    const [size, setSize] = useState(perPage);
    const [FetchDatavdo, setFetchDatavdo] = useState('');
    const [show, setShow] = useState(false);
    const { BaseURL, fontSize } = useContext(URLstateContext);

    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetCommunicationHub", {
            IICategoryID: 1,
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                setloadingshow(false);
            } else {
                setData(null);
                setloadingshow(false);
            }
        });
    }, [BaseURL]);

    let PageSize = size;

    const PaginationChange = (page, pageSize) => {
        setCurrent(page);
        setSize(pageSize);
    };

    const currentTableData = useMemo(() => {
        if (data != null && data.length > 0) {
            const firstPageIndex = (current - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            return data.slice(firstPageIndex, lastPageIndex);
        }
        return [];
    }, [current, PageSize, data]);

    const PrevNextArrow = (current, type, originalElement) => {
        if (type === 'prev') {
            return <i className="fa fa-angle-double-left" aria-hidden="true"></i>;
        }
        if (type === 'next') {
            return <i className="fa fa-angle-double-right"></i>;
        }
        return originalElement;
    };

    const clickyoutube = (event) => {
        setShow(true);
        GetPostMethodData(BaseURL + "GetVideoLink", {
            "IVsrno": event
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setFetchDatavdo(DecryptAESdata(data.data));
            }
        });
    };

    const handleClosePopup = () => {
        setShow(false);
    };

    return (

        <main id="main-content" tabIndex="-1">
        <section className="Nav-detail about-detail reachout Media-center padding-top" style={{ fontSize: `${fontSize}px` }}>
            <Container>
                <Row>
                    <Col sm={12} className="padding-left-0">
                        {(currentTableData === null) ? <h5 className="errormsgComNew" role="alert">No Data Available !!!</h5> : ''}
                        {currentTableData &&
                            currentTableData.map(({ Title, LinkLocation, DocumentDate, ThumbnailImage, CommunicationID }) => (
                                <div className="ads-container">
                                    <div className="notice-box" style={{
                                        background: "#fff",
                                        borderRadius: "12px",
                                        boxShadow: "0 4px 14px 0 rgba(0, 0, 0, .06)",
                                        padding: "15px 60px 15px 15px",
                                        position: "relative",
                                        width: "100%",
                                        marginBottom: "15px"
                                    }}>
                                        <div className="datee">
                                            {(DocumentDate != null) ? (format(parseISO(DocumentDate), 'do MMM, yyyy')) : ''}
                                        </div>
                                        <p className="title">
                                            {Title}
                                            {LinkLocation && (
                                                <span className="arrow-iconn" 
                                                >
                                                    <img
                                                        //  src={`../../../images/mc_notice-box-arrow.png`}
                                                         src={Arrow}
                                                         className="arrow-iconn curserpointer"
                                                         alt="Arrow"
                                                         onClick={(e) => {
                                                             e.preventDefault();
                                                             e.stopPropagation();
                                                             window.open(LinkLocation, '_blank');
                                                         }}
                                                         style={{
                                                            width : "40px",
                                                            height : "auto"
                                                         }}
                                                  
                                                     />
                                                {/* <IoArrowForwardCircle size={30} color="#3FB9D1" onClick={(e) => {
                 e.preventDefault();
                 e.stopPropagation();
                 window.open(LinkLocation, '_blank');
             }}/> */}
                                                </span>
                                            )}
                                            {/* {ThumbnailImage && (
                                                <span onClick={() => clickyoutube(CommunicationID)}>
                                                    <img src={ThumbnailImage} className="img-fluid" alt="Thumbnail" />
                                                </span>
                                            )} */}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        {loadingshow ? (
                            <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                                <img src={animation} alt="" aria-hidden="true" />
                                <div className="model_popup">Please Wait...</div>
                            </div>
                        ) : ""}
                        {currentTableData && currentTableData.length > 0 && (
                            <Pagination
                            align="end"
                                className="pagination-data"
                                onChange={PaginationChange}
                                total={data.length != null ? data.length : 0}
                                current={current}
                                pageSize={size}
                                showTitle = {false}
                                showSizeChanger={false}
                                itemRender={PrevNextArrow}
                            />
                        )}
                    </Col>
                </Row>
            </Container>

            {FetchDatavdo && FetchDatavdo.map(({ Title, LinkLocation }) => (
                <Modal show={show} className="modal modal-teams" onHide={handleClosePopup}>
                    <Modal.Body id="modal_info">
                        <div className="btnDiv">
                            <div className="" onClick={handleClosePopup}>
                                <AiFillCloseCircle className="btncl" />
                            </div>
                        </div>
                        <div className="youtubepopup">
                            <p>{Title}</p>
                            <div>
                                <iframe className="iframe-vdo"
                                    src={LinkLocation}
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            ))}
        </section>
        </main>
    );
}

export default MediaIntraction;


